import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';

import { AppToasterComponent } from './app-toaster.component';

@NgModule({
  imports: [AppToasterComponent, CommonModule, MatIconModule],
  exports: [AppToasterComponent],
})
export class AppToasterModule {}
